/** Optional query values for `/data-deletion/request` links. */
export const DATA_DELETION_PLATFORM = {
    GOOGLE: "google",
    APPLE: "apple",
    AMAZON: "amazon",
    SAMSUNG: "samsung",
};

export const DATA_DELETION_APP_ID = {
    JIGSAW_MUSE: "jigsaw-muse",
    SLIDING_PUZZLE_QUEST: "sliding-puzzle-quest",
    WORD_WHEEL_QUEST: "word-wheel-quest",
    WORD_SEARCH_MINI: "word-search-mini",
};

export const DATA_DELETION_PLATFORMS = Object.values(DATA_DELETION_PLATFORM);
export const DATA_DELETION_APP_IDS = Object.values(DATA_DELETION_APP_ID);

export const DATA_DELETION_APP_LABELS = {
    [DATA_DELETION_APP_ID.JIGSAW_MUSE]: "Jigsaw Muse",
    [DATA_DELETION_APP_ID.SLIDING_PUZZLE_QUEST]: "Sliding Puzzle Quest",
    [DATA_DELETION_APP_ID.WORD_WHEEL_QUEST]: "Word Wheel Quest",
    [DATA_DELETION_APP_ID.WORD_SEARCH_MINI]: "Word Search Mini",
};

/** Maps public site app IDs (`word_wheel_quest`) to deletion `appId` query values. */
export const DATA_DELETION_APP_ID_BY_SITE_ID = {
    jigsaw_muse: DATA_DELETION_APP_ID.JIGSAW_MUSE,
    sliding_puzzle_quest: DATA_DELETION_APP_ID.SLIDING_PUZZLE_QUEST,
    word_wheel_quest: DATA_DELETION_APP_ID.WORD_WHEEL_QUEST,
    word_search_mini: DATA_DELETION_APP_ID.WORD_SEARCH_MINI,
};

export const DATA_DELETION_PLATFORM_QUERY = "platform";
export const DATA_DELETION_APP_ID_QUERY = "appId";

export function isValidDataDeletionPlatform(platform) {
    if (!platform || typeof platform !== "string") return false;
    return DATA_DELETION_PLATFORMS.includes(platform.trim());
}

export function isValidDataDeletionAppId(appId) {
    if (!appId || typeof appId !== "string") return false;
    return DATA_DELETION_APP_IDS.includes(appId.trim());
}

export function readDataDeletionPlatform(search) {
    if (search == null || search === "") return null;
    try {
        const params =
            typeof search.get === "function"
                ? search
                : new URLSearchParams(
                    typeof search === "string" && search.startsWith("?")
                        ? search.slice(1)
                        : String(search),
                );
        const value = params.get(DATA_DELETION_PLATFORM_QUERY);
        if (!isValidDataDeletionPlatform(value)) return null;
        return value.trim();
    } catch {
        return null;
    }
}

/**
 * Read optional `appId` from a search string / URLSearchParams.
 * @param {string|URLSearchParams|{ get?: (k: string) => string|null }} [search]
 * @returns {string|null}
 */
export function readDataDeletionAppId(search) {
    if (search == null || search === "") return null;
    try {
        let value = null;
        if (typeof search.get === "function") {
            value = search.get(DATA_DELETION_APP_ID_QUERY);
        } else if (typeof search === "string") {
            const q = search.startsWith("?") ? search.slice(1) : search;
            value = new URLSearchParams(q).get(DATA_DELETION_APP_ID_QUERY);
        }
        if (!isValidDataDeletionAppId(value)) return null;
        return value.trim();
    } catch {
        return null;
    }
}
